import React, {PureComponent} from "react"

import {PaymentCurrencyType, StatementItem} from "@irati/types"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import StatusType from "@irati/wallet/types/enums/Status"
import authentication from "@irati/auth"
import perkboxLogo from "@irati/ui/images/logo-alt.svg"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {getNormalisedValue} from "@irati/utils/currency/formatCurrency"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"

import PrimaryDetails from "../../../PrimaryDetails"
import {StyledCard} from "../../styled"

interface Props extends InjectIntl, WithBranding {
  statementItem: StatementItem
  className?: string
  isBankTransfer?: boolean
  isSystemTransfer?: boolean
}

class AdminRewardTopUp extends PureComponent<Props> {
  static defaultProps = {
    isBankTransfer: false,
    isSystemTransfer: false
  }
  getSubTitle = () => {
    const {formatMessage, isBankTransfer} = this.props
    return isBankTransfer
      ? formatMessage({id: "wallet.statementItem.adminReward.topup.primaryDetails.subtitleBankTransfer"})
      : formatMessage({id: "wallet.statementItem.adminReward.topup.primaryDetails.subtitle"})
  }
  render() {
    const {statementItem, branding, isSystemTransfer} = this.props
    const primaryDetails = {
      image: branding.businessLogoUrl || perkboxLogo,
      title: firstnameLastname(authentication.user()),
      subTitle: !isSystemTransfer && this.getSubTitle(),
      amount: getNormalisedValue(
        statementItem.transfer?.currency === PaymentCurrencyType.Rp,
        statementItem.transfer?.currency,
        statementItem.transfer?.amount
      ),
      currency: statementItem.transfer?.currency,
      status: StatusType.REWARD_WALLET_CLEARED
    }

    return (
      <StyledCard medium noBorder>
        <PrimaryDetails imgHeightAuto data={primaryDetails} />
      </StyledCard>
    )
  }
}

export default injectIntl(withBranding(AdminRewardTopUp))
